import { Editor, Path, Point, Range } from 'slate';

/**
 * Returns all "list-items" in a given Range.
 */
export function getListItemsInRange(editor) {
  var at = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : editor.selection;

  if (!at) {
    return [];
  }

  var start = getLocationStart(at);
  var listItems = Editor.nodes(editor, {
    at,
    match: editor.isListItemNode
  });
  return Array.from(listItems).filter(_ref => {
    var [, path] = _ref;
    var [, grandparent] = Path.ancestors(start, {
      reverse: true
    });
    var rangeIsGrandhild = Path.equals(path, grandparent);
    var rangeIsDescendant = Path.isDescendant(start, path);
    var rangeStartsAfter = Path.isAfter(start, path);

    if (rangeIsDescendant) {
      // There's just one case where we want to include a "list-item" that is
      // an ancestor of the range starting point - when it's a grandparent of that point.
      // It's because the selection starting point will be in a grandchild `{ text: '' }` node.
      // <h-li>                       <--- grandparent
      //     <h-li-text>
      //         <h-text>             <--- grandchild
      //             <anchor />       <--- range starting point
      //         </h-text>
      //     </h-li-text>
      // </h-li>
      // Other ancestors are not "visually" in selection, but they are returned by `Editor.nodes`.
      return !rangeStartsAfter && rangeIsGrandhild;
    }

    return !rangeStartsAfter;
  });
}

function getLocationStart(location) {
  if (Range.isRange(location)) {
    return Range.start(location).path;
  }

  if (Point.isPoint(location)) {
    return location.path;
  }

  return location;
}